<template>
    <div class="crew-qualification-card">
        <div class="crew-qualification-row" v-for="(license, idx) in crew.licenses || []"
            :key="license.license_info.id || idx">
            <div style="width: 220px;">{{ license.license_info.name || '-' }}</div>
            <div>
                {{ license.start_date ? formatDate(license.start_date) : '' }}&nbsp;~&nbsp;{{ license.expiration_date ? formatDate(license.expiration_date) : '' }}
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        crew: { type: Object, required: true }
    },
    methods: {
        formatDate(dateStr) {
            if (!dateStr) return "";
            const d = new Date(dateStr);
            return `${d.getFullYear()}/${d.getMonth() + 1}/${d.getDate()}`;
        }
    }
};
</script>
<style scoped>
.crew-qualification-card {
    display: flex;
    flex-direction: column;
    padding: 16px 16px 16px 34px;
}

.crew-qualification-row {
    display: flex;
    height: 32px;
    gap: 10px;
    font-size: 12px;
    font-weight: bold;
}
</style>
